// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-types/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springTypesEN: PageEntry = {
  id: "post.federtypen",
  locale: "en",
  slug: "spring-types",
  seo: {
    title: "Glossary: Spring types explained simply | Dietz GmbH",
    description: "Spring types describe the variety of spring shapes and designs available. There are different types of springs, including extension springs, compression springs, torsion springs an",
  },
  type: "post",
  h1: "Glossary: Spring types explained simply",
  intro: "Spring types describe the variety of spring shapes and designs available. There are different types of springs, including extension springs, compression springs, torsion springs and leaf springs. Each spring type has specific applications and properties that make it suitable for certain tasks. Understanding the different spring types is crucial for engineers and designers to select and design the right spring for a specific application. Selecting the appropriate spring type contributes to the efficient and reliable functioning of spring systems.",
  blocks: [

  ],
};
